import React, { useEffect, useMemo, useState } from "react";
import { motion } from "framer-motion";
import { MoveRight, PhoneCall } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { routes } from "../../Constants/Routes";
import { useMediaQuery } from "../../Constants/useMediaQuery";

const Hero = () => {
  const [titleNumber, setTitleNumber] = useState(0);

  const titles = useMemo(
    () => [
      "დაბეჭდე",
      "შექმენი",
      //   "გააფორმე",
      //   "მოირგე",
      "შეუკვეთე",
    ],
    [],
  );

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setTitleNumber((prev) => (prev === titles.length - 1 ? 0 : prev + 1));
    }, 2000);

    return () => clearTimeout(timeoutId);
  }, [titleNumber, titles]);
  const navigate = useNavigate();
  const goOrder = () => {
    navigate(routes.GetOrder);
    // window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };
  const enableAnimation = useMediaQuery("(min-width: 550px)");
  return (
    <div className="w-full ">
      <div className="container mx-auto">
        <div className="flex flex-col items-center justify-center gap-5   ">
          <div>
            {/* <Button variant="secondary" size="sm" className="gap-4">
              Read our launch article
              <MoveRight className="h-4 w-4" />
            </Button> */}
          </div>

          <div className="flex flex-col gap-4">
            <h1 className="max-w-2xl text-center  font-normal tracking-tighter text-4xl ssxx:text-5xl ssm:text-6xl cxl:text-7xl ">
              <span className="text-spektr-cyan-50 font-Mtavruli">
                შენი დიზაინით
              </span>

              <span className="relative flex w-full justify-center overflow-hidden text-center md:pb-4 md:pt-1">
                &nbsp;
                {titles.map((title, index) => (
                  <motion.span
                    key={index}
                    className="absolute font-normal font-Mtavruli"
                    initial={{ opacity: 0, y: -100 }}
                    transition={{
                      type: "spring",
                      stiffness: 50,
                    }}
                    animate={
                      titleNumber === index
                        ? {
                            y: 0,
                            opacity: 1,
                          }
                        : {
                            y: titleNumber > index ? -150 : 150,
                            opacity: 0,
                          }
                    }
                  >
                    {title}
                  </motion.span>
                ))}
              </span>
            </h1>
            {/* 
              <div className="bg-primary  ">
                <div className="mx-auto max-w-container px-4 md:px-8 py-5 ">
                  <div className="flex flex-col justify-center gap-2">
                    <p className="text-center text-md  ssxx:text-lg ssm:text-xl  font-bold text-tertiary font-ArialGeo">
                      ჩვენი მხარდაჭერი კომპანიები
                    </p>
                    <div className="grid grid-cols-3 justify-center items-center gap-x-8 gap-y-4 xl:gap-x-8 ">
                      <img
                        alt="Odeaolabs"
                        src="https://www.untitledui.com/logos/logotype/color/odeao-labs.svg"
                        className="h-9 md:h-10 "
                      />
                      <img
                        alt="Kintsugi"
                        src="https://www.untitledui.com/logos/logotype/color/kintsugi.svg"
                        className="h-9 md:h-10 "
                      />
                      <img
                        alt="Magnolia"
                        src="https://www.untitledui.com/logos/logotype/color/magnolia.svg"
                        className="h-9 md:h-10 "
                      />
                    </div>
                  </div>
                </div>
              </div> */}
          </div>
          <button
            onClick={goOrder}
            className="glitch-btn hover:scale-105 duration-300 font-Mtavruli font-bold"
          >
            შეუკვეთე
          </button>
        </div>
      </div>
    </div>
  );
};

export default Hero;
